import { render } from 'preact';
import { html } from 'htm/preact';
import ContactPopupWidget from './contact-popup-widget';

function parseDataset({ input = '', fallback }) {
  try {
    return JSON.parse(input);
  } catch (err) {
    // Do nothing.
  }

  return fallback;
}

async function mount({ rootElement = null }) {
  // const preact = await import('preact');
  // const htm = await import('htm/preact');

  const { translations, language } = rootElement.dataset;

  const options = {
    translations: parseDataset({ input: translations, fallback: [] }),
    language,
  };

  render(html`
    <${ContactPopupWidget}
      translations=${options.translations}
      language=${options.language}
    />`, rootElement);
}

function init() {
  const blocks = document.querySelectorAll('.section--contact-popup');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
